<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Kategori Ekle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn
          class="mr-3"
          type="button"
          variant="danger"
          to="/Settings/Categories"
          :size="ButtonSize"
        >
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Kategoriler</span>
        </b-btn>
      </b-col>
    </b-row>

    <form @submit.prevent="AddCategory">
      <b-form-group
        class="formgroup"
        :label="Enums[index]"
        v-for="(property, index) in Category"
        :key="index"
      >
        <b-form-input type="text" v-model="Category[index]" @keypress.enter.prevent="AddCategory"></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Ekle</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Kategori Adı",
        Sort: "Sıralama"
      },
      Category: {
        Name: "",
        Sort: 0
      }
    };
  },
  computed: {
    ...mapState(["ButtonSize"])
  },
  methods: {
    async AddCategory() {
      await this.$store.dispatch("AddLoading", "AddCategory");

      await Services.Nozich.Send(
        "AddCategory",
        {
          Category: this.Category
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "AddCategory");

          if (Data.Status === "Success") {
            await this.$router.push("/Settings/Categories");
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
